import { WarningIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button";
import { Dialog } from "@/components/Dialog/Dialog";

interface Props {
  open: boolean;
  price: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const PriceChangedModal = ({
  open,
  price,
  onConfirm,
  onCancel,
}: Props) => {
  const intl = useIntl();

  return (
    <Dialog
      isOpen={open}
      actions={
        <div className="mt-4 flex w-full flex-col gap-2">
          <Button variant="contained" fullWidth onClick={onConfirm}>
            {intl.formatMessage({
              defaultMessage: "Purchase at new price",
              description:
                "Button to accept the updated price and proceed with the booking",
            })}
          </Button>
          <Button variant="outlined" fullWidth onClick={onCancel}>
            {intl.formatMessage({
              defaultMessage: "Choose another booking",
              description:
                "Button to cancel and choose a different booking when the price has changed",
            })}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col items-center gap-1">
        <WarningIcon
          size={60}
          color="var(--color-semantic-error-strong)"
          className="mb-3"
        />
        <div className="text-center text-heading-h3 text-text-primary">
          {intl.formatMessage({
            defaultMessage: "Booking price changed",
            description:
              "Dialog title shown when the booking price has changed between steps",
          })}
        </div>
        <div className="text-center text-sm text-text-primary">
          {intl.formatMessage({
            defaultMessage:
              "Looks like the price has changed. The new price is:",
            description:
              "Message body in the price-change dialog explaining the price has changed",
          })}
        </div>

        <div className="mt-1 text-center text-heading-h4 text-text-primary">
          {price}
        </div>
      </div>
    </Dialog>
  );
};
